export default __webpack_public_path__ + "static/media/comfortIcon.e7192b08.svg";